import { Injectable } from '@angular/core';
import { HttpEvent } from '@angular/common/http';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseMiscDomainService } from '@common/domain/base-misc-domain.service';
import { MediaTypes } from '@common/services/files.service';
import { arrayMapper } from '@common/operators';
import { ResultApi } from '@common/api/result-api';
import { ActivityByServerApi } from '@apps/bckp/api/models/activity';

import { ServerMiscApiService } from '../api/server-misc-api.service';
import { ActivityByServer, ActivityByServerDomain } from './models/activity';


@Injectable({
    providedIn: 'root'
})
export class ServerMiscDomainService extends BaseMiscDomainService
{
    constructor (
        private serverMiscApiService: ServerMiscApiService
    )
    {
        super();
    }

    export (qs: string, format: MediaTypes): Observable<HttpEvent<Blob>>
    {
        return this.serverMiscApiService.export(qs, format);
    }

    getActivity (qs: string): Observable<ActivityByServer[]>
    {
        return this.serverMiscApiService.getActivity(qs)
            .pipe(
                map((obj: ResultApi<ActivityByServerApi[]>): ActivityByServerApi[][] =>
                    obj.value
                ),
                arrayMapper(ActivityByServerDomain.mapperFromApi)
            );
    }

    exportActivity (qs: string, format: MediaTypes): Observable<HttpEvent<Blob>>
    {
        return this.serverMiscApiService.exportActivity(qs, format);
    }
}
